import styles from '../errorPage.module.scss';
import cx from 'classnames';
import PropTypes from 'prop-types';

const ButtonCard = ({ children, link, shouldOpenInNewTab }) => {
  const anchorProps = shouldOpenInNewTab
    ? { rel: 'noreferrer', target: '_blank' }
    : {};
  return link ? (
    <a
      className={cx(
        styles[`error-page__card`],
        'text-center card border-LightGray d-flex flex-column '
      )}
      href={link}
      {...anchorProps}
    >
      {children}
    </a>
  ) : (
    <div
      className={cx(
        styles['error-page__card'],
        'text-center card border-LightGray d-flex flex-column '
      )}
    >
      {children}
    </div>
  );
};

ButtonCard.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string,
  shouldOpenInNewTab: PropTypes.bool
};

export default ButtonCard;
